/**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

const convertToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(String(fileReader.result));
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

export default convertToBase64;
